import Typography from 'components/Typography/Typography'
import { ReactComponent as HospitalIcon } from 'assets/svg/Hospital.svg'
import './styles.scss'
import { TEmptyState } from './types'
import { AddBankAccountButton } from 'features/BankAccount/AddBankAccountButton'

export const EmptyState = ({
  onAddBankAccount,
  businessDetails
}: TEmptyState) => {
  return (
    <div className="bank-account-container__empty-state row justify-center">
      <div className="bank-account-container__empty-state__wrapper column align-center">
        <HospitalIcon />
        <Typography.Headline6 className="mt-32">
          Connect your bank account securely <br /> to receive payouts or make
          payments.
        </Typography.Headline6>
        <Typography.Paragraph className="mt-8">
          We never see your bank account numbers. <br />
          This step is handled securely by our payment provider.
        </Typography.Paragraph>
        <AddBankAccountButton
          onAddBankAccount={onAddBankAccount}
          businessDetails={businessDetails}
        />
      </div>
    </div>
  )
}
